"use client"

import { useTranslations } from "next-intl"

import { Surface, Text } from "@/components/ui"

const STEPS = ["step1", "step2", "step3"] as const

interface PdpHowToBuyProps {
  className?: string
}

export const PdpHowToBuy = ({ className }: PdpHowToBuyProps) => {
  const t = useTranslations("pdp.howToBuy")
  return (
    <section data-testid="pdp-how-to-buy" className={`flex flex-col gap-250 ${className ?? ""}`}>
      <Text as="h2" family="text" tone="inherit" className="text-copy-lg text-fg-secondary pl-50 font-medium @3xl:pl-0">
        {t("heading")}
      </Text>
      <ol className="grid grid-cols-1 gap-125 @3xl:-ml-50 @3xl:grid-cols-3 @3xl:gap-250">
        {STEPS.map((step, index) => (
          <Surface
            as="li"
            key={step}
            variant="panel"
            radius="none"
            padding="none"
            className="rounded-6x @3xl:rounded-8x flex h-9.75 items-center gap-250 px-250 @3xl:h-auto @3xl:flex-col @3xl:items-start @3xl:gap-275 @3xl:px-375 @3xl:pt-400 @3xl:pb-375"
          >
            <span className="flex w-7.75 shrink-0 justify-center @3xl:w-auto @3xl:justify-start">
              <span className="border-line-brand text-fg-brand font-text text-caption-lg @3xl:text-body-sm shrink-0 rounded-full border px-200 leading-4 @3xl:ml-50 @3xl:leading-4.25">
                {String(index + 1).padStart(2, "0")}
              </span>
            </span>
            <Text
              as="span"
              family="text"
              tone="inherit"
              className="text-little @3xl:text-little-lg text-fg-secondary min-w-0 truncate font-normal @3xl:tracking-normal @3xl:whitespace-normal"
            >
              {t(step)}
            </Text>
          </Surface>
        ))}
      </ol>
    </section>
  )
}
